module.exports = __webpack_public_path__ + "img/search.2f2ec47.6d523a52.png";